/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Download/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Download({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Download",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Download.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-ZFW6F0': alignSelf,'--mt-2-ZFW6F0': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZFW6F0': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZFW6F0': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZFW6F0': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZFW6F0': opacity,'--w-10-ZFW6F0': typeof width === 'number' ? `${width}px` : width,'--h-11-ZFW6F0': typeof height === 'number' ? `${height}px` : height,'--f-12-ZFW6F0': fill,'--a-7-ZFW6F0': isAnimated ? animation : "none",'--sd-8-ZFW6F0': isAnimated ? strokeDashoffset : 0,'--sd-9-ZFW6F0': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Download.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.759.027a3.739 3.739 0 00-2.441.546A3.763 3.763 0 002.823 2.37a3.161 3.161 0 00-2.04 1.07 3.192 3.192 0 00.301 4.492c.49.43 1.096.695 1.734.767a1.47 1.47 0 011.213-.616h.037V5.964c0-1.071.865-1.94 1.932-1.94s1.932.869 1.932 1.94v2.119h.037c.534 0 .962.259 1.223.63H9.243a2.768 2.768 0 001.837-.714 2.79 2.79 0 00.414-3.675 2.775 2.775 0 00-1.47-1.064A3.773 3.773 0 009 1.143 3.745 3.745 0 006.759.027zm-3.032 9.87l1.97 1.977c.167.168.439.168.607 0l1.969-1.977a.431.431 0 00-.304-.736h-1.11V5.964A.86.86 0 006 5.102a.86.86 0 00-.859.862v3.197h-1.11a.431.431 0 00-.304.736z"
 style={{'--f-12-ZFW6F0': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}